import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

// Clienti API
export const clientiAPI = {
  list: () => api.get('/clienti'),
  get: (id) => api.get(`/clienti/${id}`),
  create: (data) => api.post('/clienti', data),
  update: (id, data) => api.put(`/clienti/${id}`, data),
  delete: (id) => api.delete(`/clienti/${id}`),
};

// Servizi API
export const serviziAPI = {
  list: () => api.get('/servizi'),
  create: (data) => api.post('/servizi', data),
  update: (id, data) => api.put(`/servizi/${id}`, data),
  delete: (id) => api.delete(`/servizi/${id}`),
};

// Preventivi API
export const preventiviAPI = {
  list: (params) => api.get('/preventivi', { params }),
  get: (id) => api.get(`/preventivi/${id}`),
  create: (data) => api.post('/preventivi', data),
  update: (id, data) => api.put(`/preventivi/${id}`, data),
  updateStato: (id, stato) => api.patch(`/preventivi/${id}/stato?stato=${stato}`),
  delete: (id) => api.delete(`/preventivi/${id}`),
  generaDocumento: (id, templateId) => api.post(`/preventivi/${id}/genera-documento?template_id=${templateId}`),
  downloadPdf: (id) => api.get(`/preventivi/${id}/download-pdf`, { responseType: 'blob' }),
  downloadDocx: (id) => api.get(`/preventivi/${id}/download-docx`, { responseType: 'blob' }),
};

// Dashboard API
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
};

// Google Drive API
export const driveAPI = {
  connect: () => api.get('/drive/connect'),
  status: () => api.get('/drive/status'),
  disconnect: () => api.delete('/drive/disconnect'),
  listFiles: (q, folderId) => api.get('/drive/files', { params: { q, folder_id: folderId } }),
  listFolders: (q, folderId) => api.get('/drive/folders', { params: { q, folder_id: folderId } }),
  browse: (folderId, q, driveId) => api.get('/drive/browse', { params: { folder_id: folderId, q, drive_id: driveId } }),
  getSettings: () => api.get('/drive/settings'),
  updateSettings: (data) => api.put('/drive/settings', data),
};

// Change Password API
export const userAPI = {
  changePassword: (data) => api.post('/auth/change-password', data),
};

// Impostazioni Preventivo API
export const impostazioniAPI = {
  getPreventivo: () => api.get('/impostazioni/preventivo'),
  updatePreventivo: (data) => api.put('/impostazioni/preventivo', data),
  getFormattazione: () => api.get('/impostazioni/formattazione'),
  updateFormattazione: (data) => api.put('/impostazioni/formattazione', data),
};

// Modalità Pagamento API
export const modalitaPagamentoAPI = {
  list: () => api.get('/modalita-pagamento'),
  create: (data) => api.post('/modalita-pagamento', data),
  update: (id, data) => api.put(`/modalita-pagamento/${id}`, data),
  delete: (id) => api.delete(`/modalita-pagamento/${id}`),
};

// Specialisti API
export const specialistiAPI = {
  list: () => api.get('/specialisti'),
  create: (data) => api.post('/specialisti', data),
  update: (id, data) => api.put(`/specialisti/${id}`, data),
  delete: (id) => api.delete(`/specialisti/${id}`),
};

// Admin API
export const adminAPI = {
  upgrade: () => api.post('/admin/upgrade'),
  getVersion: () => api.get('/admin/version'),
  backup: () => api.post('/system/backup'),
};

export default api;
